import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { createClient } from "@supabase/supabase-js";
import Footer from "./Footer";
import { Eye } from "lucide-react";

const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY);

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      if (data.session) {
        navigate("/career");
      }
    };

    checkSession();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      return;
    }

    navigate("/career");
  };

  async function handleDiscordLogin() {
    setLoading(true);
    setError("");

    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "discord",
        options: {
          redirectTo: "https://offmetafantasy.com/career",
        },
      });

      if (error) throw error;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const handleForgotPassword = async () => {
    if (!email) {
      setError("Please enter your email first.");
      setSuccess("");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://offmetafantasy.com/reset-password",
    });

    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess("Password reset email sent. Check your inbox.");
    }
  };

  return (
    <div
      className="login-left"
      style={{
        backgroundImage: 'url("/background-grid.svg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px",
          border: "1px solid #19232f",
          borderRadius: "8px",
          alignItems: "center",
          marginTop: "6rem",
          width: "100%",
          maxWidth: "600px",
          boxSizing: "border-box",
        }}>
        <img src="/logo.svg" alt="logo" style={{ width: "180px", marginBottom: "20px" }} />
        <h1 className="login-title">Login</h1>
        {error && <p className="error-text">{error}</p>}
        {success && <p className="success-text">{success}</p>}

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column" }}>
          <input type="email" placeholder="Email" value={email} required onChange={(e) => setEmail(e.target.value)} />
          <div style={{position: "relative"}}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%", paddingRight: "40px" }}
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                right: "5px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}>
              {showPassword ? <Eye size={16} color="#3273fa"/> : <Eye size={16} color="#3273fa"/>}
            </button>
          </div>
          <button type="submit" style={{ marginTop: 16 }}>
            Log In
          </button>
        </form>
        <button
          onClick={handleDiscordLogin}
          disabled={loading}
          className="discord-button"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "20px",
            marginBottom: "20px",
            width: "100%",
            maxWidth: "392px",
            justifyContent: "center",
            padding: "14px 16px",
            backgroundColor: "#5865F2",
            color: "#fff",
            border: "none",
            fontWeight: "600",
            borderRadius: "6px",
            cursor: "pointer",
          }}>
          <img src="/discord.svg" alt="Discord" className="discord-icon" style={{ width: 20, height: 20 }} />
          {loading ? "Redirecting..." : "Login with Discord"}
        </button>
        <button
          type="button"
          onClick={handleForgotPassword}
          style={{
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
            textAlign: "center",
            margin: "0",
          }}
          className="return-link">
          Forgot password?
        </button>
        <a href="/signup" className="return-link">
          Don't have an account? <b style={{ color: "white" }}>Signup</b>
        </a>
        <a href="https://discord.gg/N5XwKXdrCY" target="_blank" rel="noopener noreferrer" className="discord-link">
          <img src="/discord.svg" alt="Discord Invite Link" className="discord-icon" />
        </a>
      </div>
      <Footer />
    </div>
  );
}
